import styled from 'styled-components';

import { Card, Flex, token } from '@zillow/constellation';

export const StyledFlex = styled(Flex)`
  border-top: 1px solid ${token('colors.gray300')};
`;

export const StyledCard = styled(Card)`
  margin: ${token('spacing.xs')}px;
  flex-grow: 1;
  flex-basis: 0;
`;
